import { green, grey, red } from '@material-ui/core/colors';

type ReviewColors = {
  positive: string;
  negative: string;
  null: string;
};

export const REVIEW_RATING_CHOICES = [
  { id: null, name: '\xa0' },
  { id: 'positive', name: 'Positiva' },
  { id: 'negative', name: 'Negativa' },
];

export const REVIEW_POSITIVE_TEXT_COLOR: string = green[700];
export const REVIEW_NEGATIVE_TEXT_COLOR: string = red[700];
export const REVIEW_NULL_TEXT_COLOR: string = grey[700];

export const REVIEW_COLORS: ReviewColors = {
  positive: REVIEW_POSITIVE_TEXT_COLOR,
  negative: REVIEW_NEGATIVE_TEXT_COLOR,
  null: REVIEW_NULL_TEXT_COLOR,
};
